module.exports = __webpack_public_path__ + "static/media/2.61ca58d7.jpg";